































































import Vue from 'vue';

import Axios from 'axios';
import { MDCRipple } from '@material/ripple';

import { Post } from './settings/admin/posts.vue';
import postComponent from './post.vue';

interface Data {
  posts: Post[];
}

export default Vue.extend({
  name: 'Home',
  data(): Data {
    const posts: Post[] = [];
    return {
      posts,
    };
  },
  mounted() {
    const selector = '.mdc-button, .mdc-icon-button, .mdc-card__primary-action';
    const ripples = [].map.call(document.querySelectorAll(selector), (el: any) => {
      return new MDCRipple(el);
    });

    const v = this;
    Axios.get('/API/posts').then((resp: any) => {
      // Order the list of posts
      resp.data.sort((a: Post, b: Post) => {
        if (a.Date < b.Date) {
          return 1;
        }
        if (a.Date > b.Date) {
          return -1;
        }
        return 0;
      });

      for (const untypedPost of resp.data) {
        const typedPost = new Post();
        typedPost.parseSameObject(untypedPost);
        v.posts.push(typedPost);
      }
    });
  },
  metaInfo: {
    title: buildTitle(),
    meta: [
      { name: 'Description', content: buildDescription() },
    ],
  },
  components: {
    postComponent,
  },
});

function buildTitle(): string {
  const en = 'Media and data solutions';
  if (navigator.language === 'en') {
    return en;
  } else if (navigator.language === 'fr') {
    return 'Solution audiovisuel et stockage pour les professionnels';
  }

  return en;
}

function buildDescription(): string {
  const en = 'We provid solutions for medas and storage';
  if (navigator.language === 'en') {
    return en;
  } else if (navigator.language === 'fr') {
    return 'Nous proposons des infrastructures et des produits haut de gamme ' +
      'pour les differents secteur de l\'audiovisuel et des medias';
  }

  return en;
}
